import Resizer from "react-image-file-resizer";

export function makeid(length) {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1000,
      1000,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

export const validateOnPaste = (e) => {
  e.preventDefault();
};

export const validateOnNumber = (e) => {
  if (e.which !== 0 && (e.which < 48 || e.which > 57)) {
    e.preventDefault();
  }
};
export const validateAlphanumeric = (e) => {
  const charCode = e.which ? e.which : e.keyCode;
  if (
    !(charCode > 47 && charCode < 58) && // numeric (0-9)
    !(charCode > 64 && charCode < 91) && // upper alpha (A-Z)
    !(charCode > 96 && charCode < 123) // lower alpha (a-z)
  ) {
    e.preventDefault();
  } else {
    return true;
  }
};

// convert file to base 64
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// convert json to form data
function buildFormData(formData, data, parentKey) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    const value = data == null ? "" : data;
    formData.append(parentKey, value);
  }
}

export function jsonToFormData(data) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

export function isEmptyObject(value) {
  return Object.keys(value).length === 0 && value.constructor === Object;
}

export const onInputToUpperCase = (e) => {
  const value = e.target.value;
  e.target.value = value.toUpperCase();
};

// API URL

export const getApiUrl = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  let API_URL = "";
  if (portal_domain) {
    API_URL = portal_domain.substring(0, portal_domain.length - 1);
  }
  return API_URL;
};

export const getApiHeader = () => {
  const token = window.sessionStorage.getItem("token");
  let headers = "";
  if (token) {
    headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
  }
  return headers;
};

// Kyc page list
export const KycPageName = {
  PAN: "pan",
  Address: "address",
  PersonalData: "personal-data",
  BankVerification: "bank-verification",
  SignatureUpload: "signature",
  VisualVerification: "visual-verification",
  IncomeProof: "income-proof",
  Review: "review",
  ESignature: "esignature",
  BrokerPayment: "broker-payment",
  Nomination: "nominee",
  DDPI: "ddpi",
  TariffScheme: "tariff-scheme",
  BrokerageScheme: "brokerage-scheme",
  NonDepositoryParticipant: "non-depository-participant",
};

// show back button by url
export const showPrevBtnByUrl = (pathName, kycStatus, kycPageName) => {
  const stageStatus = kycStatus.filter((obj) => {
    const key = Object.keys(obj)[0];
    return (
      (obj[key].status === 0 || obj[key].status === 1) &&
      kycPageName[key] === pathName.slice(1)
    );
  });
  if (stageStatus.length > 0) {
    return true;
  }
  return false;
};
// show next button by url
export const showNextBtnByUrl = (pathName, kycStatus, kycPageName) => {
  const stageStatus = kycStatus.filter((obj) => {
    const key = Object.keys(obj)[0];
    return obj[key].status === 1 && kycPageName[key] === pathName.slice(1);
  });
  if (stageStatus.length > 0) {
    return true;
  }
  return false;
};
// prev next redirect
export const getPrevAndNextRoute = (pathName, kycPageName) => {
  const keys = Object.keys(kycPageName);
  const currentKey = keys.find((key) => kycPageName[key] === pathName);
  const currentIndex = keys.indexOf(currentKey);
  const prevKey = currentIndex > 0 ? keys[currentIndex - 1] : null;
  const nextKey =
    currentIndex < keys.length - 1 ? keys[currentIndex + 1] : null;
  const prevValue = prevKey ? kycPageName[prevKey] : null;
  const nextValue = nextKey ? kycPageName[nextKey] : null;
  return {
    prev: prevValue,
    next: nextValue,
  };
};

// broker urls
export const VACHANA_API_URL = "https://scmcbrkd.in";
export const MARFATIA_API_URL = "https://scmcbrkg.in";
export const AC_CHOKSI_API_URL = "https://scmcbrkf.in";
export const DEMO_API_URL = "https://demo.betasec.in";
export const THINKREDBLUE_API_URL = "https://scmcbrke.in";
export const NAVKAR_API_URL = "https://scmcbrknav.in";
export const CONSORTIUM_API_URL = "https://consortium.brkscmcj.in";
